"use client";

import { useCallback, useEffect, useState } from "react";
import Link from "@/node_modules/next/link";
import Image from "next/image";
import Logo from "../../assets/SalonTym_Logo.png";
import {
  Box,
  Button,
  Grid,
  Typography,
  styled,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import DropDown from "./DropDown";
import LocationDialog from "../location/LocatioDialog";
import Login from "../login/Login";
import { usePathname, useRouter } from "next/navigation";
import { Address } from "../../classes/main";
import SearchBarMobileView from "../mobile-componenet/SearchBar";
import toast from "react-hot-toast";
import { Loader } from "../genericComponents/MainLoader/Loader";
import { SearchBar } from "./SearchBar";
import { CartIcon } from "./CartIcon";
import Cookies from "js-cookie";

const MainContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 96%;
  height: 110px;
  margin: 0px auto;

  @media (max-width: 600px) {
    height: auto;
    padding: 1rem 0px;
  }
`;

const LoginContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
`;

const LoginButton = styled(Button)`
  text-transform: capitalize;
  box-shadow: none;
`;

interface NavbarProps {
  setReloadCartService: any;
  reloadScrollFlag: any;
  reloadSearchPositionFlag: any;
  reloadNavBackground: any;
  visible: any;
}

const Navbar: React.FC<NavbarProps> = ({
  setReloadCartService,
  reloadScrollFlag,
  reloadSearchPositionFlag,
  reloadNavBackground,
  visible,
}) => {
  const [showLoginBox, setShowLoginBox] = useState(false);
  const [alreadyLogin, setAlreadyLogin] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [address, setAddress] = useState(new Address());
  const [updateAddress, setUpdateAddress] = useState(false);
  const [reloadLocationFlag, setReloadLocationFlag] = useState(false);
  const router = useRouter();
  const pathName = usePathname();
  const theme = useTheme();
  const isSmallScreenLogo = useMediaQuery(theme.breakpoints.down("md"));
  const isSmallScreenSearchBar = useMediaQuery(theme.breakpoints.down("sm"));

  const handleLoader = () => {
    setLoading(true);
  };
  const blankFunction = () => {};

  const handleLocationDialog = () => {
    setOpenDialog(true);
  };
  const closeDialog = () => {
    setOpenDialog(false);
  };

  const handleLogout = () => {
    if (pathName !== "/") {
      handleLoader();
    } else {
      blankFunction();
    }
    localStorage.clear();
    Cookies.remove("isAlreadyLogin");
    Cookies.remove("serviceHub");
    Cookies.remove("serviceHubSlug");
    setAlreadyLogin(false);
    toast.success("You are logged out", {
      duration: 5000,
      style: {
        padding: "16px",
      },
    });
    router.push("/");
    setReloadLocationFlag(true);
    // window.location.reload();
  };

  function handleLoginClick() {
    setShowLoginBox(true);
  }
  function handleLoginClose() {
    setShowLoginBox(false);
  }
  function handleUserLoggedIn() {
    localStorage.setItem("isAlreadyLogin", "true");
    // Cookies.set("isAlreadyLogin", "true");
    Cookies.set("isAlreadyLogin", "true", {
      expires: 365,
      secure: true,
      sameSite: "Strict", // or 'Lax', depending on your use case
    });

    setAlreadyLogin(true);
  }

  useEffect(() => {
    const value = localStorage.getItem("isAlreadyLogin");
    if (value && value == "true") {
      setAlreadyLogin(true);
    }
  }, []);

  useEffect(() => {
    const addressRow = localStorage.getItem("address");
    if (addressRow == null || addressRow == "null") {
      // handleLocationDialog();
    } else {
      setAddress(JSON.parse(atob(localStorage.getItem("address") as string)));
    }
    setUpdateAddress(false);
  }, [updateAddress]);

  const handleAddressUpdate = useCallback(() => {
    setUpdateAddress(true);
  }, []);

  return (
    <>
      <LocationDialog
        openDialog={openDialog}
        setCloseDialog={closeDialog}
        handleAddressUpdate={handleAddressUpdate}
        reloadLocationFlag={reloadLocationFlag}
      />
      <Grid
        container
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        margin="auto"
        sx={{
          position: {
            xs: !visible ? "sticky" : reloadScrollFlag ? "sticky" : "inherit",
            sm: "sticky",
          },
          background: {
            xs:
              pathName !== "/"
                ? "#fff"
                : reloadNavBackground === 0.1
                ? "#fff"
                : "none",
            sm: "#fff",
          },
          zIndex: "1000",
          display: "block",
          top: 0,
          boxShadow: {
            xs:
              pathName !== "/"
                ? "0px 0px 10px 0px rgba(0, 0, 0, 0.1)"
                : reloadNavBackground === 0.1
                ? "0px 0px 10px 0px rgba(0, 0, 0, 0.1)"
                : "none",
            sm: "0px 0px 10px 0px rgba(0, 0, 0, 0.1)",
          },
        }}
        className="navbar-scroller"
      >
        <Grid
          container
          item
          xs={12}
          sm={12}
          md={9.5}
          lg={9.5}
          margin="auto"
          sx={{
            padding: {
              xs: "0px 0.5rem",
              sm: "0px 1rem",
              md: "0px",
            },
          }}
        >
          <Box
            sx={{
              background: reloadNavBackground === 0.1 ? "#fff" : "none",
              height: reloadScrollFlag ? "107px" : "auto",
              width: "100%",
              display: "flex",
              flexDirection: "column",
              position: isSmallScreenSearchBar
                ? pathName == "/"
                  ? "relative"
                  : "relative"
                : "relative",
              top: 0,
              left: 0,
              transition: "height 0.3s ease",
            }}
          >
            <MainContainer>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Link
                  prefetch={false}
                  href={"/"}
                  style={{ textDecoration: "none", color: "inherit" }}
                  onClick={pathName !== "/" ? handleLoader : blankFunction}
                >
                  <Image
                    loading="lazy"
                    src={Logo}
                    alt="Logo"
                    height={500}
                    width={500}
                    style={{
                      width: "170px",
                      cursor: "pointer",
                      height: "auto",
                      display: isSmallScreenLogo ? "none" : "initial", // Hide on small screens
                    }}
                  />
                </Link>
                {/* --------Location Dialog-------- */}
                <Box
                  sx={{
                    display: "flex",
                    cursor: "pointer",
                    alignItems: "center",
                    marginLeft: {
                      xs: "0rem",
                      sm: "0px",
                      md: "2rem",
                    },
                  }}
                  onClick={handleLocationDialog}
                >
                  <LocationOnIcon style={{ color: "#000", fontSize: "18px" }} />
                  <Typography
                    title={address.formattedAddress}
                    sx={{
                      paddingLeft: "0.5rem",
                      maxWidth: {
                        xs: "12rem",
                        sm: "10rem",
                        md: "6rem",
                        lg: "11rem",
                      },
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {address.formattedAddress}
                  </Typography>

                  <KeyboardArrowDownIcon
                    style={{
                      color: "#15741a",
                      cursor: "pointer",
                    }}
                  />
                </Box>
              </Box>
              {/* --------Search Bar-------- */}
              <SearchBar setReloadCartService={setReloadCartService} />
              <LoginContainer
                sx={{
                  marginLeft: { xs: "5px", sm: "70px" },
                }}
              >
                {/* <CartIcon
                blankFunction={blankFunction}
                handleLoader={handleLoader}
              /> */}
                {alreadyLogin ? (
                  <DropDown handleLogout={handleLogout} />
                ) : (
                  <LoginButton
                    variant="contained"
                    color="success"
                    sx={{
                      padding: "10px 12px",
                      borderRadius: "7px",
                      marginLeft: "20px",
                      background: "#15741a",
                      width: { xs: "80px", sm: "90px", md: "90px" },
                      height: { xs: "35px", sm: "40px", md: "40px" },
                    }}
                    onClick={handleLoginClick}
                  >
                    <Typography variant="body2">Login&nbsp;</Typography>
                    <AccountCircleIcon sx={{ fontSize: "20px" }} />
                  </LoginButton>
                )}
                <Login
                  showLoginBox={showLoginBox}
                  handleLoginClose={handleLoginClose}
                  handleUserLoggedIn={handleUserLoggedIn}
                />
              </LoginContainer>
            </MainContainer>
            <Box
              sx={{
                position: "absolute",
                top: reloadSearchPositionFlag ? "62px" : "232px",
                left: "50%",
                transform: "translateX(-50%)",
                width: "96%",
                margin: "auto",
                zIndex: 1100,
                transition: "top 0.5s ease",
              }}
            >
              {isSmallScreenSearchBar ? <SearchBarMobileView /> : ""}
            </Box>
          </Box>
        </Grid>
      </Grid>
      {loading && <Loader />}
    </>
  );
};

export default Navbar;
